import { render, staticRenderFns } from "./MultipleChoiceTextImageQuestionTextAnswer.vue?vue&type=template&id=55d6cb08"
import script from "./MultipleChoiceTextImageQuestionTextAnswer.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceTextImageQuestionTextAnswer.vue?vue&type=script&lang=js"
import style0 from "./MultipleChoiceTextImageQuestionTextAnswer.vue?vue&type=style&index=0&id=55d6cb08&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports